// 由 scripts/extract-legacy-content.ts 產生，不要手改。
// 重跑：bunx tsx scripts/extract-legacy-content.ts [rawDomLegacyRoot]
//
// 來源：.tmp/ui/raw-dom/legacy/admin/<module>/<pageId>.html，經 scripts/normalize-dom.ts
//       正規化後的內容區節點序列（＝ structure 比對時會看到的那一份）。
//       143 頁裡 2 頁是「靜態內容頁」：內容區只由 hr／文字／label／iframe
//       構成，而且至少有一個 iframe。
//
// 這是**頁面本身的固定內容**，不是資料庫裡的業務資料。依 REACT-UI-EXECUTION-PLAN.md
// §3.3（固定 UI 文字必須完全一致）、§17（label 必須和原系統完全一致）、
// §18（不得用 placeholder 取代原系統實際可見資產），這些文字與影片網址必須照抄。

/** 靜態內容頁的一個內容節點。 */
export type LegacyContentItem =
  /** 分隔線 <hr>。 */
  | { readonly kind: 'rule' }
  /** 直屬文字（區塊標題）。 */
  | { readonly kind: 'text'; readonly text: string }
  /** 欄位標籤 <label>；原系統有一頁的 label 是空的，所以 text 可能是空字串。 */
  | { readonly kind: 'label'; readonly text: string }
  /** 內嵌影片 <iframe>。 */
  | { readonly kind: 'embed'; readonly src: string };

/** pageId → 原系統該頁的內容節點序列，順序與畫面一致。 */
export const LEGACY_CONTENT: Readonly<Record<string, readonly LegacyContentItem[]>> = {
  'training-education-training': [
      { kind: 'rule' },
      { kind: 'text', text: '系統簡介' },
      { kind: 'rule' },
      { kind: 'label', text: '系統簡介：' },
      { kind: 'embed', src: 'https://www.youtube.com/embed/2CWxiFl8iio' },
      { kind: 'label', text: '表單設計：' },
      { kind: 'embed', src: 'https://www.youtube.com/embed/cFG_iO2jM-M' },
      { kind: 'rule' },
      { kind: 'text', text: '功能簡介' },
      { kind: 'rule' },
      { kind: 'label', text: '訓練計畫：' },
      { kind: 'embed', src: 'https://www.youtube.com/embed/uM3OFJVq5FY' },
      { kind: 'label', text: '學習指標：' },
      { kind: 'embed', src: 'https://www.youtube.com/embed/85hYr6qg9Jk' },
      { kind: 'label', text: '課程專區：' },
      { kind: 'embed', src: 'https://www.youtube.com/embed/GCi2PYG2vUA' },
      { kind: 'label', text: '教師功能：' },
      { kind: 'embed', src: 'https://www.youtube.com/embed/mfPeYpoNtCU' },
      { kind: 'rule' },
      { kind: 'text', text: '學員訓練期程安排' },
      { kind: 'rule' },
      { kind: 'label', text: '訓練期程：' },
      { kind: 'embed', src: 'https://www.youtube.com/embed/6C-v8Jh-SpE' },
  ],
  'training-education-training-student': [
      { kind: 'text', text: '功能簡介' },
      { kind: 'rule' },
      { kind: 'label', text: '' },
      { kind: 'embed', src: 'https://www.youtube.com/embed/hTx4DfaUlKY' },
      { kind: 'text', text: '版權所有 勤紘科技 臨床教育訓練管理系統 © 2019 Ver.20251001B1' },
  ],
};
